import React from 'react';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';

import { hideModal } from '../../../services/modal/actions';

import ButtonComponent from '../../button/ButtonComponent';
import LinkButtonComponent from '../../button/LinkButtonComponent';

import './LimitedAccessModal.scss';

/**
 * Modale d'information affichée quand un membre à accès limité (abonnement expiré)
 * tente de profiter d'une offre : tracking en ligne, code promo, achat de bon d'achat.
 * Le focus initial, le piège clavier et l'aria-label sont gérés par ModalRoot.
 */
const LimitedAccessModal = ({ i18n, hideModal }) => (
    <div className="modal-limited-access">
        <div className="container-header">{i18n.HEADER}</div>
        <div className="container-body">
            <p>{i18n.TEXT_1}</p>
            <p>{i18n.TEXT_2}</p>
            <div className="container-button">
                <LinkButtonComponent
                    color="main"
                    to={PATH.ACCOUNT_JACKPOT_PATH}
                    title={i18n.JACKPOT_BUTTON}
                    text={i18n.JACKPOT_BUTTON}
                />
                <ButtonComponent color="second" onClick={hideModal} text={i18n.CLOSE_BUTTON} />
            </div>
        </div>
    </div>
);

const mapStateToProps = state => ({
    i18n: state.i18n.page.LIMITED_ACCESS_MODAL
});

const mapDispatchToProps = {
    hideModal
};

export default connect(mapStateToProps, mapDispatchToProps)(LimitedAccessModal);



// WEBPACK FOOTER //
// ./src/components/authentication/limitedaccess/LimitedAccessModal.js